import { NgModule, APP_INITIALIZER, isDevMode } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CentralDatabaseProvider } from './central-database.provider';
import { JsonFileDataParser, WorkspaceIdGeneratorService } from './services';
import {
	LocalCredentialsRepository,
	ProjectRepository,
	TableInfoRepository,
	ApiConnectionsRepository,
	WorkspaceRepository
} from './repositories';
import { InfrastructureModule } from '../infrastructure/infrastructure.module';
import { addRxPlugin } from 'rxdb';
import { RxDBDevModePlugin } from 'rxdb/plugins/dev-mode';

// todo: move up
function appInitializer(dbProvider: CentralDatabaseProvider) {
	return async () => {
		if (isDevMode()) {
			addRxPlugin(RxDBDevModePlugin);
		}
		await dbProvider.create();
	};
}

@NgModule({
	declarations: [],
	imports: [CommonModule, InfrastructureModule],
	providers: [
		CentralDatabaseProvider,
		WorkspaceRepository,
		ProjectRepository,
		JsonFileDataParser,
		WorkspaceIdGeneratorService,
		TableInfoRepository,
		LocalCredentialsRepository,
		ApiConnectionsRepository,
		{
			provide: APP_INITIALIZER,
			useFactory: appInitializer,
			deps: [CentralDatabaseProvider],
			multi: true
		}
	]
})
export class CentralDatabaseModule {}
